@if (entry.question) {
  <div class="question">{{ entry.question }}</div>
}
<mat-form-field subscriptSizing="dynamic">
  <mat-label>{{ entry.label }}</mat-label>
  <input matInput type="text" [attr.minlength]="entry.minLength" [attr.maxlength]="entry.maxLength" [formControlName]="formIndex" />
</mat-form-field>
